// extracted by mini-css-extract-plugin
export default {"e_tab":"tab_e_tab__upBmd","e_active_tab":"tab_e_active_tab__SLK1p"};